export const pageview = (url) => {
  if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;
  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
};
